import React from 'react'
import { Icon, Text } from '@components/UI'
import { useClassroomDispatch } from '../../hooks'

const ExpirationBanner = () => {
  const classroomDispatch = useClassroomDispatch()

  return (
    <div className='gp-ExpirationBanner'>
      <Text>
        Session is ending soon, in order to continue using classroom, please add
        time to the session
      </Text>

      <div className='gp-ExpirationBanner-control-container'>
        <button
          onClick={() =>
            classroomDispatch({
              type: 'set_notifications',
              payload: { expiring: false }
            })
          }
        >
          <Icon name='close' />
        </button>
      </div>
    </div>
  )
}

export default ExpirationBanner
